const { registerBlockType } = wp.blocks;
const { PanelBody, SelectControl, TextControl, ToggleControl } = wp.components;
const { InspectorControls, RichText } = wp.blockEditor;
const { useEffect, useState, useRef } = wp.element;
const { apiFetch } = wp;
const { __ } = wp.i18n;

registerBlockType('pg/insights-listing', {
  title: 'PG Insights Listing',
  icon: 'megaphone',
  category: 'widgets',
  attributes: {
    headingText: {
      type: 'string',
      default: 'Insights',
    },
    descriptionText: {
      type: 'string',
      default: 'Lorem ipsum dolor sit amet consectetur.',
    },
    sectionClass: {
      type: 'string',
      default: 'section-light-primary',
    },
    cornerPositionClass: {
      type: 'string',
      default: 'corner-left-top',
    },
    cornerBackgroundClass: {
      type: 'string',
      default: 'corner-on-light-primary',
    },
    showExcerpt: {
      type: 'boolean',
      default: true,
    },
    postsPerCategory: {
      type: 'number',
      default: 3,
    },
  },
  edit: ({ attributes, setAttributes }) => {
    const {
      headingText,
      descriptionText,
      sectionClass,
      cornerPositionClass,
      cornerBackgroundClass,
      showExcerpt,
      postsPerCategory,
    } = attributes;
    const [categories, setCategories] = useState([]);
    const [categoryPosts, setCategoryPosts] = useState({});
    const sectionWrapperRef = useRef(null);

    const darkMode = sectionClass.includes('light');

    useEffect(() => {
      // Fetch all categories
      apiFetch({ path: '/wp/v2/categories' }).then((cats) => {
        const filteredCategories = cats.filter((cat) => cat.count > 0);
        setCategories(filteredCategories);
      });
    }, []);

    useEffect(() => {
      // Fetch posts for each category
      categories.forEach((category) => {
        apiFetch({
          path: `/wp/v2/posts?categories=${category.id}&per_page=${postsPerCategory}&_embed`,
        }).then((posts) => {
          setCategoryPosts((prevState) => ({
            ...prevState,
            [category.id]: posts,
          }));
        });
      });
    }, [categories, postsPerCategory]);

    const onChangeSectionClass = (newClass) => {
      setAttributes({ sectionClass: newClass });
    };

    const onChangeCornerPositionClass = (newClass) => {
      setAttributes({ cornerPositionClass: newClass });
    };

    const onChangeCornerBackgroundClass = (newClass) => {
      setAttributes({ cornerBackgroundClass: newClass });
    };

    const handleScrollToCategory = (event, categoryId) => {
      event.preventDefault();
      const categoryElement = document.getElementById(`category-${categoryId}`);
      if (categoryElement) {
        categoryElement.scrollIntoView({ behavior: 'smooth' });
      }
    };

    return (
      <div>
        <InspectorControls>
          <PanelBody title={__('Settings')}>
            <TextControl
              label={__('Heading Text')}
              value={headingText}
              onChange={(newText) => setAttributes({ headingText: newText })}
            />
            <TextControl
              label={__('Description Text')}
              value={descriptionText}
              onChange={(newText) =>
                setAttributes({ descriptionText: newText })
              }
            />
            <SelectControl
              label={__('Section Class')}
              value={sectionClass}
              options={[
                { label: 'Light Primary', value: 'section-light-primary' },
                { label: 'Dark Primary', value: 'section-dark-primary' },
                { label: 'Light Secondary', value: 'section-light-secondary' },
                { label: 'Dark Secondary', value: 'section-dark-secondary' },
              ]}
              onChange={onChangeSectionClass}
            />
            <SelectControl
              label={__('Corner Position')}
              value={cornerPositionClass}
              options={[
                { label: 'Left-Top', value: 'corner-left-top' },
                { label: 'Left-Bottom', value: 'corner-left-bottom' },
                { label: 'Right-Top', value: 'corner-right-top' },
                { label: 'Right-Bottom', value: 'corner-right-bottom' },
              ]}
              onChange={onChangeCornerPositionClass}
            />
            <SelectControl
              label={__('Corner Background')}
              value={cornerBackgroundClass}
              options={[
                { label: 'On Light Primary', value: 'corner-on-light-primary' },
                {
                  label: 'On Light Secondary',
                  value: 'corner-on-light-secondary',
                },
                { label: 'On Dark Primary', value: 'corner-on-dark-primary' },
                {
                  label: 'On Dark Secondary',
                  value: 'corner-on-dark-secondary',
                },
              ]}
              onChange={onChangeCornerBackgroundClass}
            />
            <SelectControl
              label={__('Posts Per Category')}
              value={postsPerCategory}
              options={[
                { label: '3', value: 3 },
                { label: '6', value: 6 },
                { label: '9', value: 9 },
                { label: '12', value: 12 },
                { label: '15', value: 15 },
              ]}
              onChange={(newPerPage) =>
                setAttributes({ postsPerCategory: newPerPage })
              }
            />
            <ToggleControl
              label={__('Show Excerpt')}
              checked={showExcerpt}
              onChange={() => setAttributes({ showExcerpt: !showExcerpt })}
            />
          </PanelBody>
        </InspectorControls>
        <section className={sectionClass} ref={sectionWrapperRef}>
          <div
            className={`corner ${cornerPositionClass} ${sectionClass.replace(
              'section',
              'corner'
            )} ${cornerBackgroundClass}`}
          ></div>
          <div className="section-wrapper">
            <div className="posts-heading">
              <RichText
                tagName="h1"
                value={headingText}
                onChange={(newText) => setAttributes({ headingText: newText })}
                placeholder={__('Enter heading...')}
              />
              <RichText
                tagName="p"
                className="description"
                value={descriptionText}
                onChange={(newText) =>
                  setAttributes({ descriptionText: newText })
                }
                placeholder={__('Enter description...')}
              />
              <div className="category-list">
                {categories.map((category) => (
                  <div
                    className="category-item"
                    key={category.id}
                    onClick={(event) =>
                      handleScrollToCategory(event, category.id)
                    }
                  >
                    <span>{category.name}</span>
                    <a href={`#category-${category.id}`}></a>
                  </div>
                ))}
              </div>
            </div>
            {categories.map((category) => (
              <div
                className="posts-wrapper"
                key={category.id}
                id={`category-${category.id}`}
              >
                <div className="top">
                  <h2>{category.name}</h2>
                  <a
                    href={`/category/${category.slug}`}
                    className="btn btn-dark btn-text"
                  >
                    All {category.name}
                  </a>
                </div>
                <div className="columns-wrapper">
                  {categoryPosts[category.id] &&
                  categoryPosts[category.id].length > 0 ? (
                    categoryPosts[category.id].map((post) => (
                      <div className="column" key={post.id}>
                        <div className="image">
                          <img
                            src={
                              post._embedded['wp:featuredmedia']
                                ? post._embedded['wp:featuredmedia'][0]
                                    .source_url
                                : '/wp-content/themes/positiongreen/resources/images/placeholders/placeholder_7.png'
                            }
                            alt={post.title.rendered}
                          />
                          <p>
                            <span>{category.name}</span>
                            <a
                              href={post.link}
                              className="btn btn-light btn-outline btn-icon btn-small"
                            ></a>
                          </p>
                        </div>
                        <h3>{post.title.rendered}</h3>
                        {showExcerpt && post.excerpt.rendered && (
                          <p
                            className="description"
                            dangerouslySetInnerHTML={{
                              __html: post.excerpt.rendered,
                            }}
                          ></p>
                        )}
                      </div>
                    ))
                  ) : (
                    <p>No posts found in this category.</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>
      </div>
    );
  },
  save: () => null,
});
